/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import analytics from './ga'
import SearchForm from './components/SearchForm'
import Loader from './components/Loader'
import SearchResult from './components/SearchResult'
import SearchResultMultiple from './components/SearchResultMultiple'
import ErrorMessage from './components/ErrorMessage'
import Vue from 'vue'

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */


/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */


const app = new Vue({
  el: '#main',
  components: {
    SearchForm,
    Loader,
    SearchResult,
    SearchResultMultiple,
    ErrorMessage
  },
  created() {
    this.$root.$on('input-inserted', () => {
      analytics.inputInserted();
    })
    this.$root.$on('search-clicked', () => {
      analytics.searchClicked();
    })
    this.$root.$on('error-occured', (error, message) => {
      analytics.errorOccured(message || error);
    })
    this.$root.$on('tt-result-received', () => {
      analytics.resultReceived();
    })
    this.$root.$on('download-click', (type) => {
      analytics.sendDownloadFormat(type);
    })
  },
  mounted() {
    const langButton = document.querySelector('.header__lang-button')
    if (langButton) {
      const langMenu = document.querySelector('.header__lang-list')
      langButton.addEventListener('click', () => {
        langMenu.classList.toggle('header__lang-list_show')
        const screenWidth = screen.width;
        if (screenWidth <= 630) {
          document.body.classList.add('lang-menu');
          langButton.classList.add('hide')
          document.querySelector('.header__lang-close-button').classList.add('show')
          document.body.addEventListener('click', (event) => {
            const el = event.target.closest('[class*="header"]'); // finds any parent with class containing "header"

            if (!el) {
              document.body.classList.remove('lang-menu');
              langMenu.classList.remove('header__lang-list_show');
              langButton.classList.remove('hide');
              document.querySelector('.header__lang-close-button').classList.remove('show');
            }
          })
        }
      })
    }

    const langCloseBtn = document.querySelector('.header__lang-close-button')
    if (langCloseBtn) {
      const langMenu = document.querySelector('.header__lang-list')
      langCloseBtn.addEventListener('click', () => {
        document.body.classList.remove('lang-menu');
        langMenu.classList.remove('header__lang-list_show');
        langButton.classList.remove('hide');
        langCloseBtn.classList.remove('show');
      })
    }

    const burgerButtonMenu = document.querySelector('.header__burger')
    if (burgerButtonMenu) {
      const mobileMenu = document.querySelector('.mobile-menu')
      burgerButtonMenu.addEventListener('click', () => {
        mobileMenu.classList.add('mobile-menu_show')
      })
      const closeButtonMenu = document.querySelector('.mobile-menu__button')
      closeButtonMenu.addEventListener('click', () => {
        mobileMenu.classList.remove('mobile-menu_show')
      })
    }
    const showQuestion = document.querySelectorAll('.faq__btn')

    showQuestion.forEach(function (elem) {
      elem.addEventListener('click', (event) => {
        let index = event.target.dataset.target
        if(index === undefined) {
          index = event.target.parentNode.dataset.target
        }
        const content = document.querySelector(`.faq__paragraph[data-target="${index}"`)
        const img = document.querySelector(`.faq__btn-img[data-target="${index}"`)

        img.classList.toggle('faq__btn-img_disable')
        content.classList.toggle('faq__paragraph_show')

      })
    })

    const backToTop = document.querySelector('.backTop');

    if (backToTop) {
      let visible = false;

      window.addEventListener('scroll', () => {
        if (window.pageYOffset > 220) {
          if (!visible) {
            visible = true;
            backToTop.classList.add('backTop_visible');
          }
        } else {
          if (visible) {
            visible = false;
            backToTop.classList.remove('backTop_visible');
          }
        }
      });

      backToTop.addEventListener('click', (event) => {
        event.preventDefault();

        if ('scrollBehavior' in document.documentElement.style) {
          window.scrollTo({
            left: 0,
            top: 0,
            behavior: 'smooth',
          });
        } else {
          window.scrollTo(0, 0);
        }
      });
    }
    const input = document.getElementById('input')
    if (input) {
      const mainText = input.placeholder
      const animatedText = 'https://';
      let index = 0;
      setInterval(() => {
        input.placeholder = mainText + animatedText.substring(0, index + 1);
        index = (index + 1) % (animatedText.length + 10);
      }, 300)
    }



  }
})
